module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-stats"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Listeners (Live/Peak)")]), _vm._v(" "), _c('span', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.stats.currentListeners + " (" + _vm.stats.peakListeners + ")"))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Average listen time")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "timesince": _vm.stats.averageListenTime,
      "iscalculated": true,
      "countdown": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Time since last repeat")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "title": _vm.getLastRepeatInfo(),
      "timesince": _vm.repeatinfo.last_repeat,
      "countdown": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("No repeat record")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "timesince": _vm.repeatinfo.no_repeat_record,
      "iscalculated": _vm.shouldRepeatRecordTick(),
      "countdown": false,
      "shouldtick": _vm.shouldRepeatRecordTick()
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f4065f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/RadioStats.vue
// module id = 273
// module chunks = 1